const newUser = {
  name: '',
  email: '',
  address: '',
  phone: '',
  city: '',
  country: '',
  picture: '',
  language: '',
  password: '',
  distributors: [],
};

export default newUser;
